export const defaultConfig = [
  {
    name: 'age',
  },
  {
    name: 'goal',
  },
  {
    name: 'biting',
    age: 'puppy',
  },
  {
    name: 'potty_training',
    age: 'puppy',
  },
  {
    name: 'commands',
    age: 'adult',
  },
  {
    name: 'commands_puppy',
    age: 'puppy',
  },
  {
    name: 'being_home_alone_puppy',
    age: 'puppy',
  },
  {
    name: 'hygiene',
    age: 'puppy',
  },
  {
    name: 'chewing',
    age: 'puppy',
  },
  {
    name: 'jumping_on_people',
    age: 'adult',
  },
  {
    name: 'being_for_food',
    age: 'adult',
  },
  {
    name: 'being_home_alone',
    age: 'adult',
  },
  {
    name: 'obedience',
    age: 'adult',
  },
  {
    name: 'picking_up_from_the_ground',
    age: 'adult',
  },
];
